/** Exact CSS port of ReadOSTranscriptAttachmentPresentationAdapter.
 * Original is read-only; provenance is recorded under vendor/reados/iPadAttachments.
 * Native host injection is required in addition to the copied WebBundle CSS. */
export const IPAD_ATTACHMENT_PRESENTATION_STYLE = String.raw`
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-bubble {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  overflow: visible;
  padding: 0;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-main {
  align-items: flex-end;
  gap: calc(var(--chat-body-font-size, 16px) * 0.52);
  overflow: visible;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments {
  order: -2;
  align-self: flex-end;
  justify-content: flex-end;
  max-width: 100%;
  margin-top: 0;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-content {
  align-self: flex-end;
  width: auto;
  max-width: 100%;
  padding: calc(var(--chat-body-font-size, 16px) * 0.52)
    calc(var(--chat-body-font-size, 16px) * 0.78);
  border-radius: calc(var(--chat-body-font-size, 16px) * 1.04);
  background: var(--chat-user-bubble-bg);
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments {
  gap: calc(var(--chat-body-font-size, 16px) * 0.42);
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment:not(.attachment-image) {
  box-sizing: border-box;
  gap: calc(var(--chat-body-font-size, 16px) * 0.38) !important;
  min-height: max(44px, calc(var(--chat-body-font-size, 16px) * 2.4));
  min-width: 0;
  overflow: hidden;
  padding: calc(var(--chat-body-font-size, 16px) * 0.38)
    calc(var(--chat-body-font-size, 16px) * 0.72) !important;
  border-radius: 999px;
  font-size: calc(var(--chat-body-font-size, 16px) * 0.9) !important;
  line-height: 1.2;
  background: color-mix(in srgb, var(--chat-user-bubble-bg) 48%, var(--app-bg) 52%) !important;
  border: 1px solid color-mix(in srgb, var(--title) 8%, transparent) !important;
  color: var(--title) !important;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment-icon {
  width: calc(var(--chat-body-font-size, 16px) * 1.55);
  height: calc(var(--chat-body-font-size, 16px) * 1.55);
  flex-basis: calc(var(--chat-body-font-size, 16px) * 1.55);
  border-radius: calc(var(--chat-body-font-size, 16px) * 0.38);
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment:not(.attachment-image) svg {
  width: calc(var(--chat-body-font-size, 16px) * 0.92) !important;
  height: calc(var(--chat-body-font-size, 16px) * 0.92) !important;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment:not(.attachment-image) {
  max-width: 100%;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment:not(.attachment-image) > span:last-child {
  min-width: 0;
  max-width: min(42em, calc(100vw - 96px));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
      
`;

/** Web presentation adjustment requested after reviewing the sent capsules.
 * Keep the copied adapter above intact; neutral colors must not inherit the
 * transcript bundle's warm paper palette. */
export const WEB_ATTACHMENT_PRESENTATION_STYLE = String.raw`
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-main {
  gap: 4px;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments {
  gap: 6px;
  align-items: flex-end;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment:not(.attachment-image) {
  min-height: 32px;
  padding: 5px 10px !important;
  gap: 6px !important;
  background: #f3f3f3 !important;
  border-color: #e5e5e5 !important;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment-icon {
  width: 16px;
  height: 16px;
  flex-basis: 16px;
  background: transparent;
}
html[data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment:not(.attachment-image) svg {
  width: 14px !important;
  height: 14px !important;
}
html[data-theme="dark"][data-readex-transcript-theme="codex"] .message.user:has(.message-attachments) .message-attachments .attachment:not(.attachment-image) {
  background: #292929 !important;
  border-color: #3a3a3a !important;
}
html[data-readex-transcript-theme="codex"] .message.user .message-attachments .attachment-image {
  position: relative;
  width: 112px;
  height: 112px;
  max-width: 112px;
  flex: 0 0 112px;
  border-radius: 12px;
}
html[data-readex-transcript-theme="codex"] .message.user .message-attachments .attachment-image-thumbnail {
  width: 112px;
  height: 112px;
  object-fit: cover;
}
html[data-readex-transcript-theme="codex"] .message.user .message-attachments .attachment-image:focus-visible {
  outline: 2px solid var(--title);
  outline-offset: 2px;
}
.reados-attachment-image-status {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 8px;
  font-size: 12px;
  text-align: center;
}
`;
